/* eslint-disable no-underscore-dangle */
function PathBuilder() {
  // values used to aid in determining the path
  let _values = {};
  // and object to hold numebr of seats (numseats) and date
  let _search = {};
  let _forceSummary;

  // rules depending on the page
  // these are utilized in app.js to set a backpath
  const pageRules = {
    AddOns: defaultRule,
    ChangeCancel: changeCancelRule,
    Summary: summaryPageRule,
    Payment: paymentPageRule,
    Profile: profilePageRule,
  };

  // go back to events or reservations
  function defaultRule(values) {
    const {
      eventPath,
      venueId,
    } = values;

    if (eventPath) {
      return eventPath;
    } if (venueId) {
      return `/venues/${venueId}`;
    }
    return undefined;
  }

  function changeCancelRule() {
    return '/account/reservations-and-notify';
  }

  function paymentPageRule() {
    return '/reservation-details';
  }

  function summaryPageRule(values) {
    const {
      addOnsTemplateId,
      venueId,
    } = values;

    if (venueId && addOnsTemplateId) {
      return `/venues/${venueId}/add-ons/${addOnsTemplateId}`;
    }

    return defaultRule(values);
  }

  function profilePageRule(values) {
    if (_forceSummary) {
      return '/reservation-details';
    }

    return summaryPageRule(values);
  }

  // `venues/${venueId}`
  function backPath(name) {
    const f = pageRules[name] || defaultRule;
    return f(_values);
  }

  // `venues/${venueId}`?seats=${search?.seats}&date=${search?.date}`
  function backPathWithSearchString() {
    return `${backPath()}${getSearchString()}`;
  }

  function getSearch() {
    return _search;
  }

  function getSearchString() {
    return Object.keys(_search).reduce(
      (str, key) => `${str}&${key}=${_search[key]}`,
      ''
    ).replace('&', '?');
  }

  function setForceSummary(val) {
    _forceSummary = val;
  }

  function setValues(vals) {
    _values = { ...vals };
  }

  function setSearch(
    seats = 2,
    date = (new Date()).toISOString().substring(0, 10)
  ) {
    let d = date;
    if (typeof d === 'object') {
      d = date?.toISOString().substring(0, 10);
    }
    _search = {
      date: d,
      seats,
    };
  }

  function isAccountPage(path) {
    return /\/account\//.test(path);
  }

  function isConfirmationPage(path) {
    return /\/confirmation/.test(path);
  }

  function isUpdatePhonePage(path) {
    return /\/update-phone/.test(path);
  }

  /* value maintained on resyRouter Redux slice
  * @param {string} path - path as candidate to be returned
  * @param {string} prevPath - path to be returned if candidate fails
  * @return {string}
  */
  function logoutRedirect(path, prevPath) {
    const { isGda, venueId } = _values;
    if (isConfirmationPage(path)) {
      return `/venues/${venueId}`;
    }
    /* if the booking flow for this reservation is global dining access
    * or if it is an account page or update phone
    * don't update the return path of
    * the individual who logs out
    * you do NOT want them logged out and returning to a gda flow or account page
    */
    if (isGda || isAccountPage(path) || isUpdatePhonePage(path)) {
      return prevPath;
    }
    return path;
  }

  return {
    backPath,
    backPathWithSearchString,
    getSearch,
    getSearchString,
    isAccountPage,
    logoutRedirect,
    setForceSummary,
    setSearch,
    setValues,
  };
}

export default PathBuilder;
